import type { RefObject } from 'preact/compat';
import { useState } from 'preact/hooks';

import { getTracerModules } from '@apptracer/sdk/lite';
import { CaptchaWidget } from '@vkid/captcha';

import type { WidgetLocale } from '../types/widgetLocale';

import { packageName } from '../../config';
import { getAuthCaptchaLink } from '../api/getAuthCaptchaLink';

/** Хук для работы с VK Капчей */
export const useVkCaptcha = (
  ref: RefObject<HTMLDivElement>,
  onSuccess?: (successToken: string) => void,
  locale: WidgetLocale = 'ru'
) => {
  const tracerError = getTracerModules(packageName).error;

  // Инициализация новой капчи
  const captchaWidget = new CaptchaWidget();

  const [successCaptchaToken, setSuccessCaptchaToken] = useState<string | null>(null);

  /** Метод для создания и показа капчи */
  const handleCaptchaCreate = async () => {
    // Получаем ссылку на капчку от бэкенда
    const { link: captchaLink } = await getAuthCaptchaLink();

    if (ref && 'current' in ref && ref.current) {
      try {
        const successToken = await captchaWidget.show({
          container: ref.current,
          iframeSrc: captchaLink,
          captchaType: 'type_1',
          scheme: 'light',
          view: 'block',
          lang: locale,
        });

        // Если есть токен, сохраняем его
        if (successToken) {
          setSuccessCaptchaToken(successToken);

          onSuccess?.(successToken);
          return;
        }
      } catch (error) {
        if (error === 'close') {
          tracerError?.error('Ошибка при отображении капчи');
          return;
        }
      }
    }

    return;
  };

  return {
    /** Метод показа капчи */
    onShowCaptcha: handleCaptchaCreate,
    /** success_token от капчи для обмена на jwt */
    successCaptchaToken,
    setSuccessCaptchaToken,
  };
};
